package com.devi3east.bashbuddy.footer.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.devi3east.bashbuddy.features.events.common.EventRepository
import com.devi3east.bashbuddy.footer.requests.ContactFormRequest
import com.devi3east.bashbuddy.account.profile.domain.models.Profile
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class FooterViewModel(
    private val repository: EventRepository
): ViewModel() {
    private val _uiState = MutableStateFlow(ContactUsUiState())
    val uiState = _uiState.asStateFlow()

    private var hasInitializedFromProfile = false

    fun initializeFromProfile(profile: Profile) {
        if (hasInitializedFromProfile) return

        _uiState.value = _uiState.value.copy(
            name = profile.name
                ?: profile.displayName
                ?: _uiState.value.name,
            email = profile.email.takeIf { it.isNotBlank() }
                ?: _uiState.value.email,
            phone = profile.phone
                ?: _uiState.value.phone
        )

        hasInitializedFromProfile = true
    }

    fun updateName(value: String) { _uiState.value = _uiState.value.copy(name = value) }
    fun updateEmail(value: String) { _uiState.value = _uiState.value.copy(email = value) }
    fun updatePhone(value: String) { _uiState.value = _uiState.value.copy(phone = value) }
    fun updateMessage(value: String) { _uiState.value = _uiState.value.copy(message = value) }

    fun submitContactForm() {
        val state = _uiState.value
        if (state.name.isBlank() || state.email.isBlank() || state.message.isBlank()) {
            _uiState.value = state.copy(errorMessage = "Please fill in all required fields.")
            return
        }

        viewModelScope.launch {
            _uiState.value = state.copy(isLoading = true, successMessage = null, errorMessage = null)
            val result = repository.sendContact(
                ContactFormRequest(
                    name = state.name,
                    email = state.email,
                    phone = state.phone.ifBlank { null },
                    message = state.message
                )
            )

            _uiState.value = if (result.isSuccess) {
                state.copy(
                    isLoading = false,
                    successMessage = "Thanks for reaching out! Your message has been sent — we’ll be in touch soon.",
                    name = "",
                    email = "",
                    phone = "",
                    message = ""
                )
            } else {
                state.copy(
                    isLoading = false,
                    errorMessage = "Failed to send message: ${result.exceptionOrNull()?.message}"
                )
            }
        }
    }
}